import { defineMessages } from 'react-intl'
import { SelectLocales } from '@web/walter-ui-kit/components/Select/types'

// ui-kit - src/components/Select/MainSelect
export const lang: SelectLocales = defineMessages({
    resetButton: {
        id: 'mainSelect.defaultResetButton',
        defaultMessage: 'Reset',
    },
    confirmButton: {
        id: 'mainSelect.defaultConfirmButton',
        defaultMessage: 'Confirm',
    },
    itemsPlural: {
        id: 'mainSelect.defaultItemsPlural',
        defaultMessage: '{itemsCount, plural, =0 {# items} one {# item} other {# items}}',
    },
    itemsNotFound: {
        id: 'mainSelect.defaultItemsNotFound',
        defaultMessage: 'No results found',
    },
})
